import { render } from "./BalanceHis.vue?vue&type=template&id=794251ea&scoped=true"
import script from "./BalanceHis.vue?vue&type=script&lang=js"
export * from "./BalanceHis.vue?vue&type=script&lang=js"

import "./BalanceHis.vue?vue&type=style&index=0&id=794251ea&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794251ea"]])

export default __exports__